import { defineStore } from 'pinia'
import api from '@/modules/account/api'
import { useAccountStore } from '@/modules/account/store/accountStore'
import { OrderStatus } from '@bigbank/dc-common/clients/http/account/modules/pending-payments/pending-payment.types'

const PENDING_PAYMENT_PAGE_SIZE = 50
const PENDING_PAYMENT_PAGE_NUMBER = 1

export const usePendingPaymentStore = defineStore('pendingPayment', {
  state: () => ({
    pendingPayments: [],
    isPendingPaymentsLoading: false,
    selectedIban: null,
    pageSize: PENDING_PAYMENT_PAGE_SIZE,
    pageNumber: PENDING_PAYMENT_PAGE_NUMBER
  }),
  actions: {
    async searchPendingPayments () {
      this.isPendingPaymentsLoading = true

      try {
        if (!this.selectedIban) {
          const accountStore = useAccountStore()
          await accountStore.getAccountsForPayment()
          this.setSelectedIban(accountStore.paymentAccounts[0].iban)
        }

        const response = await api.searchPendingPayments({
          pageSize: this.pageSize,
          pageNumber: this.pageNumber,
          fromIban: [this.selectedIban]
        })
        this.pendingPayments = response.values
      } catch (err) {
        this.$apm.captureError(err)
      } finally {
        this.isPendingPaymentsLoading = false
      }
    },
    async createPendingPayment (body) {
      try {
        await api.createPendingPayment(body)
      } catch (err) {
        this.$apm.captureError(err)
      }
    },
    setSelectedIban (iban) {
      this.selectedIban = iban
    }
  },
  getters: {
    waitingForConfirmation () {
      return this.pendingPayments.filter(payment => payment.orderStatus === OrderStatus.NotConfirmed)
    }
  }
})
